import CircleProgressBar from 'components/CircleProgressBar';
import React from 'react';

type Props = {
  title: string;
  subtitle: string;
  image: any;
  percentage: number;
};

export default function AssignedCard({
  title,
  subtitle,
  image,
  percentage
}: Props) {
  return (
    <div>
      <div className="w-[20rem] rounded-md bg-white">
        <div className="border-b border-[#7F8B9433]">
          <div className="flex items-center justify-between p-3 px-5">
            <span className="text-sm font-semibold text-[#353535]">
              {title}
            </span>
            <span className="text-xs text-[#34475E99]">{subtitle}</span>
          </div>
        </div>
        <div className="flex items-center justify-between px-4">
          <img src={image} alt="Bank Logo" />
          <div className="mr-3 flex flex-col items-center">
            <CircleProgressBar progress={percentage} />
            <span className="text-xs text-[#A5A5A5]">
              {percentage}% Assigned
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
